/* Terace の部品の共通 JS（小さく保つ。セクション固有の動きはセクションの {% javascript %} に書く） */
(() => {
  document.documentElement.classList.add('t-js');

  // 表示アニメーション（フェードイン）：main の中の t- セクションの中身を、画面に入ったらふわっと出す。
  // 印を付けなくても自動（見出し・文・写真・ボタン・リストの1件ずつ）。止めたい所は data-t-reveal="off"、
  // まとめて1つで出したい所は data-t-reveal を付ける。テーマ設定「Terace：動き」で全体を切れる
  const root = document.documentElement;
  const ready = () => root.classList.add('t-reveal-ready');
  const on = root.classList.contains('t-reveal') && !matchMedia('(prefers-reduced-motion: reduce)').matches
    && !(window.Shopify && Shopify.designMode) && 'IntersectionObserver' in window;
  const UNIT = 'h1,h2,h3,h4,h5,h6,p,dl,table,figure,picture,img,video,iframe,form,blockquote,a,button,.t-media';
  const mark = (el, out) => {
    for (const c of el.children) {
      if (c.matches('script,style,template,noscript,[aria-hidden="true"]:empty,[data-t-reveal="off"]')) continue;
      if (c.hasAttribute('data-t-reveal') || c.matches(UNIT) || c.localName.includes('-')) { out.push(c); continue; }
      if ((c.matches('ul,ol') && c.children.length > 12)) { out.push(c); continue; }   // 多すぎるリストはまとめて1つ
      mark(c, out);                                                                     // ul・ol は1件ずつ（li の中を見る）
    }
    return out;
  };
  const io = on ? new IntersectionObserver((entries) => {
    let i = 0;
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      const el = e.target;
      io.unobserve(el);
      const d = Math.min(i++, 4) * 80;                 // 一緒に入ったものは 0.08 秒ずつずらす（最大 0.32 秒）
      el.style.transitionDelay = d + 'ms';
      el.classList.add('is-in');
      setTimeout(() => {                               // 出終わったら印を外す（部品のホバー・切り替えの動きに戻す）
        el.removeAttribute('data-t-reveal'); el.classList.remove('is-in'); el.style.transitionDelay = '';
      }, 900 + d);
    });
  }, { rootMargin: '0px 0px -10% 0px' }) : null;
  const watch = (scope) => {
    scope.querySelectorAll('main .t-section, main [data-t-reveal-scope]').forEach((s) => {
      if (s.closest('[data-t-reveal="off"]') || s.parentElement.closest('.t-section')) return;
      mark(s, []).forEach((el) => {
        if (el.closest('[data-t-reveal="off"]')) return;
        if (!el.getClientRects().length) return;      // 今の幅で出ていないもの（t-sp-only など）は触らない
        el.setAttribute('data-t-reveal', '');
        io.observe(el);
      });
    });
  };
  if (on) { root.classList.add('t-reveal-on'); watch(document); }
  else document.querySelectorAll('[data-t-reveal]:not([data-t-reveal="off"])').forEach((el) => el.removeAttribute('data-t-reveal'));
  ready();

  // 開閉（data-t-toggle="対象のid"）：ハンバーガーメニュー・よくある質問など
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-t-toggle]');
    if (!btn) return;
    const target = document.getElementById(btn.dataset.tToggle);
    if (!target) return;
    const open = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', String(open));
    target.toggleAttribute('data-open', open);
    document.documentElement.classList.toggle('t-lock', open && btn.hasAttribute('data-t-lock'));
  });

  // 閉じるだけのボタン（data-t-close="対象のid"）：全画面メニューの × など。Esc キーでも閉じる
  const close = (id, focus = true) => {
    const target = document.getElementById(id);
    if (!target || !target.hasAttribute('data-open')) return;
    target.removeAttribute('data-open');
    document.querySelectorAll(`[data-t-toggle="${id}"]`).forEach((b) => { b.setAttribute('aria-expanded', 'false'); if (focus) b.focus(); });
    document.documentElement.classList.remove('t-lock');
  };
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-t-close]');
    if (btn) close(btn.dataset.tClose);
  });
  // メニュー（data-t-lock で開くもの）の中のリンクを押したら、飛ぶと同時にメニューを閉じる（ページ内リンクでも開いたまま残さない。決まりは coding/HTML制作/drawer-menu.md）
  // ページ内リンク（同じページの #id）は、するすると動いてその場所まで流れる（動きを減らす設定の人には一瞬で飛ぶ）
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href]');
    if (!link || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const menu = link.closest('[data-open][id]');
    if (menu && document.querySelector(`[data-t-toggle="${menu.id}"][data-t-lock]`)) close(menu.id, false);
    const url = new URL(link.href, location.href);
    if (!url.hash || url.origin !== location.origin || url.pathname !== location.pathname || (url.search && url.search !== location.search)) return;
    const id = decodeURIComponent(url.hash.slice(1));
    const target = id === 'top' ? document.body : document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const pad = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;   // 固定ヘッダーの分（html の scroll-padding-top）
    window.scrollTo({ top: target === document.body ? 0 : target.getBoundingClientRect().top + window.scrollY - pad, behavior: reduce ? 'auto' : 'smooth' });
    history.pushState(null, '', url.hash);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') document.querySelectorAll('[data-t-close]').forEach((b) => close(b.dataset.tClose));
  });
})();
